import React, { useEffect, useState } from "react";
import "../../Agents/createAgent.scss";
import "./SingleAgentRight.scss";
import "../../Dialer/Dialer.scss";
import { useNavigate } from "react-router-dom";
import { flask_url } from "../../../../Socket";
import axios from "axios";
import { toast } from "react-toastify";
import "../../Dialer/LoaderScreen.scss";

const SingleAgentRight = () => {
  const [startCall, setstartCall] = useState(true);

  const [showMannudalDialer, setShowMannudalDialer] = useState("manual");
  const [selectedOption, setSelectedOption] = useState(null);
  const [userLogs, setUserLogs] = useState([]);

  const handleShowMannudalDialer = (tab) => {
    setShowMannudalDialer(tab);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // -----------------------------------------------------------------------------

  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
  var data = localStorage.getItem("phone");
  console.log("data", data);
  if (data !== undefined && data !== null && data != "undefined") {
    console.log("here");
    var phone = JSON.parse(data);
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
    } else {
      var email = JSON.parse(localStorage.getItem("email"));
      if (email === "admin@gmail.com") {
        navigate("/dashboard");
      } else {
        navigate("/singleagent");
      }
    }
  }, []);

  const Logout = () => {
    try {
      localStorage.removeItem("bearerToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("phone");
      localStorage.removeItem("name");

      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  var userId = JSON.parse(localStorage.getItem("userId"));
  var phone = JSON.parse(localStorage.getItem("phone"));
  var value = localStorage.getItem("name");
  if (value && value != "undefined") {
    var name = JSON.parse(localStorage.getItem("name"));
  }

  var phoneNumber = `+${phone}`;

  const [calls, setCalls] = useState([]);
  const [lastObject, setLastObject] = useState([]);
  const [agentDetails, setAgentDetails] = useState({});
  const [currentAgentData, setCurrentAgentData] = useState([]);
  const [agentStatus, setAgentStatus] = useState(null);
  const [agentOldLogs, setAgentOldLogs] = useState([]);

  // useEffect(() => {
  //   const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

  //   newSocket.onopen = (event) => {
  //     console.log("WebSocket connection opened:", event);
  //     const initialMessage = "Hello, WebSocket!";
  //     newSocket.send(initialMessage);
  //   };

  //   newSocket.onmessage = async (event) => {
  //     const message = event.data;

  //     console.log(typeof message);

  //     const data = await JSON.parse(message);

  //     if (phone) {
  //       const agentStatus = data[data.length - 1]?.AgentStatus.hasOwnProperty(`+${phone}`);
  //       setAgentStatus(data[data.length - 1]?.AgentStatus[`+${phone}`]);

  //       // console.log("agent Status", agentStatus);

  //       setCalls(data);
  //       setLastObject(data[data.length - 1]);

  //       setAgentDetails(data[data.length - 1]?.agentDetails);
  //     }
  //   };

  //   return () => {
  //     newSocket.close();
  //   };
  // }, []);

  useEffect(() => {
    const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

    newSocket.onopen = (event) => {
      console.log("WebSocket connection opened:", event);
    };

    newSocket.onmessage = async (event) => {
      let data = await JSON.parse(event.data);

      if (phone) {
        if (data.event === "simple_dialer") {
          console.log("agent_data_response_ai_dialer", data);

          const responce = data?.data;

          console.log("res", responce);

          if (phone) {
            const agentStatus = responce[responce.length - 1]?.AgentStatus.hasOwnProperty(`+${phone}`);
            setAgentStatus(responce[responce.length - 1]?.AgentStatus[`+${phone}`]);

            console.log("agent Status", agentStatus);

            setCalls(responce);
            setLastObject(responce[responce.length - 1]);

            setAgentDetails(responce[responce.length - 1]?.agentDetails);
          }
        }
      }
    };

    return () => {
      newSocket.close();
    };
  }, []);

  useEffect(() => {
    console.log("Phone :", phoneNumber);

    if (agentDetails?.hasOwnProperty(phoneNumber)) {
      setCurrentAgentData(agentDetails[phoneNumber]);
    }
  }, [agentDetails]);

  // console.log("All Objects Socket Data :", calls);
  console.log("Last Object Socket Data :", lastObject);

  console.log("Current Agent Socket Data :", currentAgentData);
  // console.log("Single Agent Details Data :", agentDetails);
  console.log("Socket Agen Status ----------------", agentStatus);
  console.log("Old Logs", agentOldLogs);

  const agentStopCall = async () => {
    try {
      if (currentAgentData.length === 0) {
        toast.error("No number in queue");
        return;
      }

      axios
        .post(`${flask_url}/PauseAgent`, { Agent_Number: `+${phone}` })
        .then((response) => {
          console.log("Response:", response.data);
          toast.success("Call Paused");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      toast.error("SOmeting went wrong");
      console.log(error);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/customer/profile`;
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      axios
        .get(apiUrl, config)
        .then((response) => {
          console.log("profile data", response.data);

          localStorage.setItem("phone", JSON.stringify(response?.data?.phone));
          localStorage.setItem("name", JSON.stringify(response?.data?.userName));
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const agentStartCall = async () => {
    try {
      if (currentAgentData.length === 0) {
        toast.error("No number in queue");
        return;
      }

      axios
        .post(`${flask_url}/ResumeAgent`, { Agent_Number: `+${phone}` })
        .then((response) => {
          console.log("Response:", response.data);
          toast.success("Call Resumed");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      toast.error("SOmeting went wrong");
      console.log(error);
    }
  };

  useEffect(() => {
    setTimeout(async () => {
      getOldLogs();
    }, 5000);
  }, []);

  const getOldLogs = async () => {
    try {
      if (!phone) {
        throw new Error("phone number is missing");
        return;
      }
      axios
        .get(`${flask_url}/get_data_agent/+${phone}`)
        .then((response) => {
          console.log("Response data:", response?.data);
          setAgentOldLogs(response?.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return phone ? (
    <div className="create-agent-wrapper">
      <div className="topBar">
        <div className="bruceDiv">
          <img className="bruceImg" src="/images/Dashboard/bruceImg.png" alt="..." />
          <h3>{name ? name : ""}</h3>
        </div>

        <div className="login-btn">
          <button onClick={Logout}>Logout</button>
        </div>
      </div>

      <div className="needHelpDiv">
        <a href="/needHelp">Need Help?</a>
      </div>

      <div className="singleAgent-main-container mt-3">
        {showMannudalDialer === "manual" && (
          <div className="">
            <div className="dialerInputs-container">
              <div className="dial-opt-div d-flex justify-content-end">
                <div className="pr-4">
                  <button className={`themebtn-1 mr-3 ${showMannudalDialer === "manual" ? "addBorder" : ""}`} onClick={() => handleShowMannudalDialer("manual")}>
                    Agent Screen
                  </button>
                  <button className={`themebtn-1 mr-3 ${showMannudalDialer === "oldlogs" ? "addBorder" : ""}`} onClick={() => handleShowMannudalDialer("oldlogs")}>
                    Old Logs
                  </button>
                </div>
              </div>
            </div>
            <div className="d-flex gap-5">
              <div className="singleAgent-details-container">
                <span>
                  <label>Agent Number:</label>
                  <p>{phone ? phone : ""}</p>
                </span>
                <span>
                  <label>On Going Number :</label>
                  <p>{lastObject?.PhoneNumber}</p>
                </span>

                <div className="status-span">
                  <label>Status:</label>
                  <p>{agentStatus}</p>
                </div>

                <div className="agentDial-div">
                  {startCall ? (
                    <button
                      button
                      className="start-dailing-btn-agent"
                      onClick={() => {
                        agentStartCall();
                      }}
                    >
                      Resume
                    </button>
                  ) : (
                    <button className="pause-dailing-btn-agent">Pause</button>
                  )}
                  &nbsp; &nbsp;
                  <button className="end-dailing-btn-agent" onClick={agentStopCall}>
                    pause
                  </button>
                </div>
              </div>

              <p className="">In Queue :</p>
              <div className="customer-call-threeGrid-container">
                {currentAgentData &&
                  currentAgentData.length != 0 &&
                  currentAgentData.map((item) => (
                    <>
                      <div className="dialer-callingOption-box">
                        <h6>
                          Client Name: <span> {item?.CustomerName} </span>
                        </h6>
                        <h6>
                          Service Type: <span> {item?.ServiceType} </span>
                        </h6>
                        <h6>
                          Client Number: <span> {item?.PhoneNumber} </span>
                        </h6>
                      </div>
                    </>
                  ))}
              </div>
            </div>
          </div>
        )}

        {showMannudalDialer === "oldlogs" && (
          <div className="">
            <div className="dialerInputs-container">
              <div className="dial-opt-div d-flex justify-content-between">
                <h3>Old Logs</h3>
                <div className="pr-4">
                  <button className={`themebtn-1 mr-3 ${showMannudalDialer === "manual" ? "addBorder" : ""}`} onClick={() => handleShowMannudalDialer("manual")}>
                    Agent Screen
                  </button>
                  <button className={`themebtn-1 mr-3 ${showMannudalDialer === "oldlogs" ? "addBorder" : ""}`} onClick={() => handleShowMannudalDialer("oldlogs")}>
                    Old Logs
                  </button>
                </div>
              </div>
            </div>

            <table class="contact-table">
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Service Type</th>
                  <th>Customer Phone Number</th>
                  <th>Agent Phone Number</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {agentOldLogs.data && agentOldLogs.data.length != 0 ? (
                  agentOldLogs?.data?.map((item) => {
                    return (
                      <tr>
                        <td>{item?.dialerdata?.CustomerName}</td>
                        <td>{item?.dialerdata?.ServiceType}</td>
                        <td>{item?.dialerdata?.PhoneNumber}</td>
                        <td>{item?.dialerdata?.agent_number}</td>
                        <td>{item?.dialerdata?.call_status}</td>
                      </tr>
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
        )}
        {/* </div> */}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default SingleAgentRight;
